export default __webpack_public_path__ + "static/media/282034.82afd86b.png";